<template>
    <div class="prelative clearfix">
        <div v-for="option in filter.inputs.mode.options" :key="option.value">
            <div class="form-group">
                <label class="form-label label-auto" :for="'mode' + option.value">
                    <input
                        type="radio"
                        v-model="mode"
                        :value="option.value"
                        :id="'mode' + option.value"
                    />
                    {{ option.label }}
                </label>
            </div>
            <div class="form-group form-group-32" v-if="needValue && mode == option.value">
                <div class="form-input block">
                    <input
                        type="text"
                        class="wp-10"
                        v-model.trim="value"
                        :placeholder="$t.__('common.labels.search')"
                        :required="needValue"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],

    data() {
        return {
            mode: '',
            value: '',
        };
    },

    computed: {
        data() {
            return {
                mode: this.mode,
                value: this.value,
            };
        },

        needValue() {
            return (
                this.mode == 'contain' ||
                this.mode == 'dontcontain' ||
                this.mode == 'is' ||
                this.mode == 'isnot' ||
                this.mode == 'startlike'
            );
        },
    },
};
</script>
